import { useContext, useState, useEffect, useReducer } from 'react'
import { Grid } from '@mui/material'
import HeroCarousel from './HeroCarousel.js'
import { listArticles } from '../data/index.js'
import { getSiteConfigRoutes } from '../../community/siteProvider'

export default function HomePageCarousel(props = {}) {
  const { cycleDurationMs } = props
  const [allArticles, setAllArtices] = useState([])

  const initialState = {
    // '{sitedId}': {
    //   loading: false,
    //   loadingMore: false,
    //   articles: [],
    //   totalAvailable: undefined,
    //   totalLoaded: 0,
    //   nextToken: undefined,
    // }
  }

  function articleReducer(state, action) {
    const _state = structuredClone(state)
    const [siteId, key, value] = action
    _state[siteId] = _state[siteId] || {}
    _state[siteId][key] = value

    return _state
  }

  const [newsMap, dispatchNews] = useReducer(articleReducer, initialState)

  const isIgnorableGraphError = (err) => {
    const status = err?.response?.status
    return status === 403 || status === 404
  }

  useEffect(() => {
    const siteConfigs = getSiteConfigRoutes();
    let active = true

    const load = async () => {
      const articlesBySite = {}
      await Promise.allSettled(
        siteConfigs.map(async (siteConfig) => {
          const { siteId, sitePath } = siteConfig
          try {
            for await (const articlesResponse of listArticles(
              { news: true, featured: true },
              true,
              0,
              undefined,
              3,
              false,
              siteConfig)
            ) {
              if (!active) return
              const { articles, totalSize, nextLink, totalLoaded } = articlesResponse
              if (articles) {
                const prevArticles = articlesBySite[siteId] || []
                const newArticles = [...prevArticles, ...articles].map(a => ({ ...a, sitePath }))
                articlesBySite[siteId] = newArticles
                dispatchNews([siteId, 'articles', newArticles])
                dispatchNews([siteId, 'totalAvailable', totalSize])
                dispatchNews([siteId, 'nextToken', nextLink])
                if (totalLoaded) dispatchNews([siteId, 'totalLoaded', totalLoaded])
              }
            }
          } catch (err) {
            if (isIgnorableGraphError(err)) {
              console.warn(`Skipping Community Hub site ${sitePath} due to Graph ${err?.response?.status}`)
              return
            }
            throw err
          }
        })
      )
    }

    load()

    return () => {
      active = false
    }
  }, [])

  useEffect(() => {
    const newArts = []
    for (const key of Object.keys(newsMap)) {
      newArts.push(...newsMap[key].articles)
    }
    setAllArtices(newArts)
  }, [newsMap])

  return (
    <Grid
      container
      spacing={0}
      sx={{
        height: '100%'
      }}
    >

      <HeroCarousel
        editable={false}
        featured
        news
        published={true}
        articles={allArticles}
        loading={false}
        loadingMore={false}
        totalArticlesAvailable={0}
        moreAvailable={false}
        loadMoreArticles={() => { }}
        cycleDurationMs={cycleDurationMs}
      />

    </Grid>
  )
}